import { Component, NgZone, } from '@angular/core';
import { Platform, ModalController, MenuController, AlertController, NavController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import { Network } from '@ionic-native/network/ngx';
import { NavigationEnd, Router, Route } from '@angular/router';

import { ShareService } from '../services/ShareService';
import { appCommonMethods } from '../services/appCommonMethods';
import { ALL_MESSAGE, API_ENDPOINT, ALL_CONSTANTS, APP_VERSION, APP_CODE } from '../services/config';

import { NoInternetConnectionPage } from './no-internet-connection/no-internet-connection.page';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { TranslateService } from '@ngx-translate/core';
import { GetData } from 'src/services/GetData';
import { Subscription } from 'rxjs';

import { AppVersion } from '@ionic-native/app-version/ngx';
import { AuthenticationService } from '../services/AuthenticationService';
import { ActionSheetController } from '@ionic/angular';

import { InAppBrowser, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Location } from '@angular/common';
import { Deeplinks } from '@awesome-cordova-plugins/deeplinks/ngx';
import { MoengagePushService } from 'src/services/moengage-push.service';
import { Events } from 'src/services/Events';
import { first } from 'rxjs/operators';
import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';
import { FirebaseAnalytics } from '@awesome-cordova-plugins/firebase-analytics/ngx';
import { AuthGuard } from 'src/services/authServices';
import { FooterTabsComponent } from './components/footer-tabs/footer-tabs.component';

declare var window: any;
declare var MoECordova: any;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {

  private subscription: Subscription;
  showRoleSwitch: boolean = false;
  activateNewRole: boolean = true;
  public appPages = [
    {
      title: 'Home',
      url: '/home',
      icon: 'icon-home',
      icon_active: 'icon-home-active',
      open: false,
      status: true
    },
    {
      title: 'My Business',
      icon: 'icon-portfolio',
      open: false,
      status: true,
      children: [
        {
          title: 'Profile',
          url: '/profile',
          open: true,
          icon: 'icon-profile-icon',
          isChild: false
        },
        {
          title: 'Sales Capture',
          url: '/sale-capture',
          open: false,
          icon: 'icon-sale-capture',
          isChild: true
        },
        {
          title: 'Sales Claim',
          url: '/sales-capture-t2',
          open: false,
          icon: 'icon-sale-capture',
          isChild: true
        },
        {
          title: 'Add Employees',
          url: '/user-management',
          open: false,
          icon: 'icon-user-management',
          isChild: true
        },
        {
          title: 'Add Sales Personnel',
          open: false,
          url: '/user-management-t2',
          icon: 'icon-user-management',
          isChild: true
        },
        {
          title: 'My Performance',
          url: '/performance-chart-t2',
          open: true,
          icon: 'icon-leaderboard',
          isChild: false
        },
        {
          title: 'ASO Visits',
          url: '/rate-visit',
          open: false,
          icon: 'icon-aso-visits',
          isChild: true
        },
        {
          title: 'Query',
          url: '/query',
          open: false,
          icon: 'icon-contact-us',
          isChild: true
        }
      ]
    },
    {
      title: 'Benefits',
      icon: 'icon-proconnect-benefits',
      open: false,
      status: true,
      children: [
        {
          title: 'Schemes',
          url: '/scheme',
          open: false,
          icon: 'icon-schemes',
          isChild: true
        },
        {
          title: 'ProConnect Exclusives',
          url: '/product-request',
          open: false,
          icon: 'icon-rate',
          isChild: true
        },
        {
          title: 'Bids',
          url: '/bid-list',
          open: false,
          icon: 'icon-bid',
          isChild: true
        },
        {
          title: 'My Loyalty Points',
          url: '/reward-catalogue',
          open: false,
          icon: 'icon-reward-catloge',
          isChild: true
        },
        {
          title: 'Redemption History',
          url: '/voucher-listing',
          open: false,
          icon: 'icon-redemption-history',
          isChild: true
        },
        {
          title: 'Point History',
          url: '/point-history',
          open: false,
          icon: 'icon-point-history',
          isChild: true
        },
        {
          title: 'Greetings',
          url: '/greeting-listing',
          open: false,
          icon: 'icon-birthday-greeting',
          isChild: true
        }
      ]
    },
    {
      title: 'Products & Updates',
      icon: 'icon-brand-speaks',
      status: true,
      open: false,
      children: [
        {
          title: 'Whats new',
          url: '/whats-new',
          open: false,
          icon: 'icon-news',
          isChild: true
        },
        {
          title: 'Brochures',
          url: '/brochure-download',
          open: false,
          icon: 'icon-brochure-line',
          isChild: true
        },
        {
          title: 'Product Catalogue',
          url: '/category-list',
          open: false,
          icon: 'icon-product',
          isChild: true
        },
        {
          title: 'Videos',
          url: '/videos',
          open: false,
          icon: 'icon-play',
          isChild: true
        }
      ]
    },
    {
      title: 'Lenovo Cares',
      url: '/csr-activity',
      open: false,
      icon: 'icon-csr',
      status: true
    },
    {
      title: 'Service Contact Matrix',
      url: '/contact-matrix',
      open: false,
      icon: 'icon-service-contract-matrix',
      status: true
    },
    {
      title: 'Services Upsell',
      url: '/services',
      open: false,
      icon: 'icon-upsell',
      status: true
    },
    {
      title: 'FAQs',
      url: '/faq',
      icon: 'icon-faq',
      open: false,
      status: true
    },

    // {
    //   title: 'Product Launch ',
    //   url: '/launch-live',
    //   icon: 'icon-terms-conditions'
    // },

    // {
    //   title: 'Escalation Matrix',
    //   url: '/escalation-matrix',
    //   icon: 'icon-play'
    // },


    {
      title: 'Language',
      url: '/language-new',
      icon: 'icon-language',
      open: false,
      status: true
    },
    {
      title: 'Terms',
      url: '/terms',
      icon: 'icon-terms-conditions',
      open: false,
      status: true
    },
    // {
    //   title: 'Switcher',
    //   url: '/switch',
    //   icon: 'icon-switcher',
    //   open: false,
    //   status: this.showRoleSwitch
    // },
    // {
    //   title: 'Activate',
    //   url: '/activate-role',
    //   icon: 'icon-refer',
    //   open: false,
    //   status: this.activateNewRole
    // },
    {
      title: 'Logout',
      url: '/logout',
      open: false,
      icon: 'icon-logout',
      status: true
    },

    // {
    //   title: 'catalouge-detail',
    //   url: '/catalouge-detail',
    //   icon: 'icon-graduate-diploma'
    // },
    // {
    //   title: 'voucher-listing',
    //   url: '/voucher-listing',
    //   icon: 'icon-graduate-diploma'
    // }
  ];
  netConnection: boolean;
  userData: any = {};
  confirm: any;
  confirmPopOpen: boolean = false;

  currLan: any = '';
  currPage: String = '';
  currUrl: string = '';
  userLoggedIn: boolean = false;
  appVersionNo: any;
  appCode: any;
  appVersionCode: any;
  appToken: any;
  revision_id: any = '';
  status: boolean = false;
  showUpdate: boolean = false;
  updateUrl: any = '';
  currentRole: any = "";
  selectedRole: any;
  t3UserData: any;
  t2UserData: any;
  showFooter: boolean;
  popPage: any = "";
  // blockItemsForT2:any = ['/sale-capture','/voucher-listing','/reward-catalogue','/user-management'];
  blockItemsForT2: any = ['/sale-capture', '/user-management'];

  blockItemsForT3: any = ['/sales-capture-t2', '/user-management-t2', '/performance-chart-t2'];
  menuOpen() {
    this.status = !this.status;
  }

  isChildActive(p) {
    if (p.children && p.children.length) {
      if(p.icon == 'icon-brand-speaks' && this.userData.role && ( this.userData.role.toLowerCase() == 'aso' ||  this.userData.role.toLowerCase() == 'cpm')){
        p.title="Brand Speak"
      }else if(p.icon == 'icon-brand-speaks'){
        p.title="Products & Updates"         
      }
      for (let i = 0; i < p.children.length; i++) {
        let child = p.children[i];
        if (this.router.isActive(child.url, true)) {
          return true;
          break;
        }
      }
    }
    return false;
  }
  subMenuOpen(item) {

    if (item.open == true) {
      item.open = false;
      return false;
    }
    else {
      this.appPages.forEach(element => {
        if (element.children) {
          element.children.filter((item, index) => {
            if (item.url == '/sale-capture') {
              item.title = (this.userData.role.toLowerCase() == 'aso' || this.userData.role.toLowerCase() == 'srd' || this.userData.role.toLowerCase() == 'lep') ? 'Sales Captured' : 'Sales Capture';
              // this.auth.menuArray.filter(item1 => {
              //   // item.title = (this.userData.role.toLowerCase() == 'aso' || this.userData.role.toLowerCase() == 'srd' || this.userData.role.toLowerCase() == 'lep') ? 'Inbox' : item.title;
              //   console.log('Element : ', item1.route)
              //   if (item1.route == '/query') {
              //     // item.title = item1.machine_name;
              //   }
              // })
            }else if (item.url == '/user-management' && this.userData.manage_user_type) {
              item.title = (this.userData.manage_user_type.toLowerCase() != 'employee' && this.userData.manage_user_type.toLowerCase() != 'coowner') ? 'Add Employees' : 'Employees';
            }else if (item.url == '/user-management-t2' && this.userData.manage_user_type) {
              item.title = (this.userData.manage_user_type.toLowerCase() != 'so' && this.userData.manage_user_type.toLowerCase() != 'sm') ? 'Add Sales Personnel' : 'Sales Personnel';
            }
            return item;
          })
        }
      });
    }
    if (item.children.length > 0) {
      this.appPages.forEach(element => {
        if (element.title == item.title) {
          element.open = true;
        } else {
          element.open = false;
        }
      });
    }
  }

  forgotPasswordPop: boolean = false;
  password1Sel: any = "";
  password1: any = "";
  password2Sel: any = "";
  password2: any = "";
  passwordError: any = {};

  // switchArray = []; 
  activateRoleArray = [];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public nativeStorage: NativeStorage,
    public router: Router,
    public network: Network,
    public shareService: ShareService,
    public modalCtrl: ModalController,
    public appCom: appCommonMethods,
    public screenOrientation: ScreenOrientation,
    public menu: MenuController,
    public alertCtrl: AlertController,
    public events: Events,
    public navCtrl: NavController,
    public translate: TranslateService,
    public getPostData: GetData,
    public appVersion: AppVersion,
    public auth: AuthenticationService,
    public actionSheetController: ActionSheetController,
    private inAppBrowser: InAppBrowser,
    private location: Location,
    private _deeplink: Deeplinks,
    private _ngZone: NgZone,
    private _moengage: MoengagePushService,
    private firebase: FirebaseX,
    private firebaseAnalytics: FirebaseAnalytics,
    public authGuard: AuthGuard,
    private footerTab: FooterTabsComponent,
  ) {
    console.log("App Init");
    this.initializeApp();

    /** to initialize/reset user details on login */
    this.platform.ready().then(() => {
      this.events.subscribe('user:loggedin', (flag, time) => {
        if (flag) {
          this.appCom.getLocalStorageItem("userData").then((data: any) => {
            if (data) {
              console.log('data');
              // this.showRoleSwitch = false;
              this.activateNewRole = false;
              this.setSwitcher();
              this.activateRole();
              console.log("userdata", data.data);
              this.userData = data.data;
              this.userData['first_name'] = (this.userData['name']).split(" ")[0];
              if (this.userData.role == "t2" || this.userData.role == "T2") {
                // this.getT2Data();  // to  refersh user data
                // this.checkForT3Role();
              } else {
                // this.getUserData();  // to  refersh user data
                // this.checkForT2Role();
              }

              // this.getUserRevision(); // to refersh user revision data
              if (!ALL_CONSTANTS.IS_STAGING) {
                this.firebaseAnalytics.setUserId(this.userData['userId']);
                this.firebaseAnalytics.setUserProperty("name", this.userData['name']);
                this.firebaseAnalytics.setUserProperty("region", this.userData['regionMapping']);
                this.firebaseAnalytics.setUserProperty("state", this.userData['stateMapping']);
                this.firebaseAnalytics.setUserProperty("city", this.userData['cityMapping']);
              }
              this.checkAppUpdate();
            }
          });
        }
      });


      /** to change menu details on click */
      this.events.subscribe('menu:pagechange', (flag, page) => {
        if (flag) {
          this.currPage = page;
        }
        this.appCom.getLocalStorageItem("userData").then((data: any) => {
          if (data) {
            this.userData = data.data;
            this.userData['first_name'] = (this.userData['name']).split(" ")[0];
            console.log("Page change data", this.userData);
            if (!ALL_CONSTANTS.IS_STAGING) {
              // window.FirebasePlugin.setUserId(this.userData['userId']);
              // window.FirebasePlugin.setUserProperty("name", this.userData['name']);
              // window.FirebasePlugin.setUserProperty("region", this.userData['regionMapping']);
              // window.FirebasePlugin.setUserProperty("state", this.userData['stateMapping']);
              // window.FirebasePlugin.setUserProperty("city", this.userData['cityMapping']);
            }

          }
        });
      });


      this.events.subscribe('appPageChanges', res => {
        console.log('res Data page changes : ', res)
        this.appPages = res;
        console.log('Data of new appPages : ', this.appPages)
        this.setSwitcher();
      })

    });


    /** to initialize/reset on language change */
    this.events.subscribe('language:changed', (flag, time) => {
      if (flag) {
        this.appCom.getLocalStorageItem("language").then((data: any) => {
          if (data && data.text != '') {
            this.currLan = data.text;
            this.translate.setDefaultLang(data.lang);
          }
          else {
            this.currLan = 'English';
            this.translate.setDefaultLang('en');
          }
        },
          (err) => {
            this.currLan = 'English';
            this.translate.setDefaultLang('en');
          });
      }
    });



    /** to show menu selected */
    this.events.subscribe('menu:changed', (curMenu, time) => {
      if (curMenu) {
        this.currPage = curMenu;
      }
    });
  }

  async ionViewDidEnter() {
    this.activateNewRole = false;

  }

  checkchildren(children: any) {
    console.log
    let isAllowed = false;

    for (let i = 0; i < children.length; i++) {
      if (this.auth.isAuthenticated(children[i].url)) {
        isAllowed = true;
        break;
      }
    }
    return isAllowed
  }

  public async ngOnInit(): Promise<void> {
    this.subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let current = event.url;
        for (var i = 0; i < this.appPages.length; i++) {
          if (this.appPages[i]['url'] == current) {
            console.log(",current", current);
            this.currPage = this.appPages[i]['title'];
            if (!ALL_CONSTANTS.IS_STAGING) {
              this.firebaseAnalytics.logEvent("page_view", { page: this.appPages[i]['title'], title: this.appPages[i]['title'] });
              this.firebaseAnalytics.setCurrentScreen(this.appPages[i]['title']);
            }
          }
        }
      }
    });
  }

  openPage(page, url) {
    console.log('page open Event : ', page)
    let userId;
    let pageData = page;
    if (page.userId) {
      userId = page.userId
    }
    if (!page.isChild) {
      this.appPages.forEach(element => {
        element.open = false;
      });
    }
    if (page && page.url) {
      url = page.url;
      page = page.title;
    }
    if (url == '/contact-matrix') {
      let todayDate: any = new Date()
      let time = Math.floor(todayDate);
      let url = '';
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      var device_type = '';
      if (/android/i.test(userAgent)) {
        device_type = 'android';
      }
      else {
        device_type = 'ios';
      }
      // +'&device_type=' + device_type
      if (this.userData.aso_type == "t2" || this.userData.aso_type == "T2") {
        url = 'live/contact-matrix-v2/contact-matrix-t2-v2.html?v=' + time + '&device_type=' + device_type;
      } else {
        url = 'live/contact-matrix-v2/contact-matrix-t3-v2.html?v=' + time + '&device_type=' + device_type;
      }
      url = ALL_CONSTANTS.LIVE_URL + url;
      console.log('matrix url ', url);
      if(!ALL_CONSTANTS.IS_STAGING){
        this.firebaseAnalytics.setCurrentScreen('Contact Matrix');
        this.firebaseAnalytics.logEvent("page_view",  {content_type:"Click",item_id:"Contact Matrix", page:'Contact Matrix'});
      }
      const options: InAppBrowserOptions = {
        location: 'no',//Or 'no' 
        hidden: 'no', //Or  'yes'
        clearcache: 'yes',
        clearsessioncache: 'yes',
        zoom: 'no',//Android only ,shows browser zoom controls 
        hardwareback: 'yes',
        mediaPlaybackRequiresUserAction: 'no',
        shouldPauseOnSuspend: 'no', //Android only 
        closebuttoncaption: 'Close', //iOS only
        disallowoverscroll: 'no', //iOS only 
        toolbar: 'yes', //iOS only 
        enableViewportScale: 'no', //iOS only 
        allowInlineMediaPlayback: 'no',//iOS only 
        presentationstyle: 'pagesheet',//iOS only 
        fullscreen: 'yes',//Windows only   
        hideurlbar: 'yes',
        beforeload: 'yes',
        usewkwebview: 'yes',
      };
      let target = this.appCom.platform.is('android') ? '_self' : '_blank';
      const browser = this.inAppBrowser.create(url, target, { location: 'no', options }).show();

    }
    else if (url == '/logout') {
      this.logout();
    }
    else if (url == '/home') {
      this.router.navigate([url]);
    }
    else if (url == '/switch') {
      // if (this.userData.role == 't2' || this.userData.role == 'T2') {
      //   this.currentRole = 't2';
      //   this.selectedRole = 't3';
      //   this.popPage = this.router.url;
      //   this.roleChange();
      // } else {

      //   this.currentRole = 't3';
      //   this.selectedRole = 't2';
      //   this.popPage = this.router.url;
      //   this.roleChange();
      // }
      this.popPage = this.router.url.split('?')[0];
      this.appCom.showRolePopUp(pageData.res).then(val => {
        console.log('tres ', val);
        this.roleChangeDynamic(val, null, true);
      })

      // this.appCom.showPopAlert('hi', '', 'Ok', this.userData.role);
      // /** to initialize/reset user details on login */
      // this.events.subscribe('roleAlertClosed', (flag, role, page) => {
      //   if (flag) {
      //     console.log("EVENT ", flag, "Data", role, page);
      //     this.popPage = page;
      //     if (role == 't2') {
      //       this.currentRole = 't3';
      //       this.selectedRole = role;

      //     } else {
      //       this.currentRole = 't2';
      //       this.selectedRole = role;
      //     }

      //     console.log("this.currentRole this.selectedRole", this.currentRole, this.selectedRole)
      //     this.roleChange();
      //   }
      // });
    }
    else if (url == '/faq') {
      let todayDate: any = new Date()
      let time = Math.floor(todayDate);
      let url = '';
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      var device_type = '';
      if (/android/i.test(userAgent)) {
        device_type = 'android';
      }
      else {
        device_type = 'ios';
      }
      if (this.userData.aso_type == "t2" || this.userData.aso_type == "T2") {
        // url = 'https://lenovot3.experiencecommerce.com/live/faqs/faq.html?v='+time; //staging
        // url = 'https://cmslenovot3.experiencecommerce.com/lenovo-faq/faq.html';
        url = 'live/faq/faq.html?v=' + time; //Live
      } else {
        // url = 'https://lenovot3.experiencecommerce.com/live/faqs/faq.html?v='+time; //staging
        // url = 'https://cmslenovot3.experiencecommerce.com/lenovo-faq/faq.html';
        url = 'live/faq/faq.html?v=' + time; //Live

      }
      url = ALL_CONSTANTS.LIVE_URL + url;
      if(!ALL_CONSTANTS.IS_STAGING){
        this.firebaseAnalytics.setCurrentScreen('FAQ');
        this.firebaseAnalytics.logEvent("page_view", {content_type:"Click",item_id:"FAQ", page:'FAQ'});
      }
      const options: InAppBrowserOptions = {
        location: 'no',//Or 'no' 
        hidden: 'no', //Or  'yes'
        clearcache: 'yes',
        clearsessioncache: 'yes',
        zoom: 'no',//Android only ,shows browser zoom controls 
        hardwareback: 'yes',
        mediaPlaybackRequiresUserAction: 'no',
        shouldPauseOnSuspend: 'no', //Android only 
        closebuttoncaption: 'Close', //iOS only
        disallowoverscroll: 'no', //iOS only 
        toolbar: 'yes', //iOS only 
        enableViewportScale: 'no', //iOS only 
        allowInlineMediaPlayback: 'no',//iOS only 
        presentationstyle: 'pagesheet',//iOS only 
        fullscreen: 'yes',//Windows only   
        hideurlbar: 'yes',
        beforeload: 'yes'
      };

      let target = this.appCom.platform.is('android') ? '_self' : '_blank';
      const browser = this.inAppBrowser.create(url, target, { location: 'no', options }).show();
    }
    else if (url == '/activate-role') {
      this.currPage = page;
      let param = {
        role: pageData.role,
        aso_type: pageData.aso_type
      }
      this.appCom.setLocalStorageItem('activeRole', param).then(() => {
        if (url) {
          this.router.navigate([url]);
        }
        this.menu.close();
      });
    }
    else if (url == "/change-password") {
      this.resetForgotPassword();
      this.openPasswordPop();
    }
    else if (this.currPage != page) {
      this.currPage = page;
      if (url) {
        this.router.navigate([url]);
      }
      this.menu.close();
    }
  }

  initializeApp() {
    // this.showRoleSwitch = false;
    this.activateNewRole = false;
    this.platform.ready().then(async () => {
      this.statusBar.styleDefault();
      this.statusBar.overlaysWebView(false);
      this.statusBar.backgroundColorByHexString('#7a99ff');
      // this.splashScreen.hide();


      if (this.appCom.platform.is('cordova')) {
        window.FirebasePlugin.hasPermission(function (data) {
          if (!data.isEnabled) {
            window.FirebasePlugin.grantPermission();
          }
        });

        window.FirebasePlugin.getToken((token) => {
          // save this server-side and use it to push notifications to this device
          if (token) {
            this.appToken = token;
            console.log('$$$$$ Token : ', token)
            this.appCom.setLocalStorageItem("firebaseToken", { data: this.appToken });
          }
        }, function (error) {
          console.error(error);
        });

        window.FirebasePlugin.onTokenRefresh((token) => {
          // save this server-side and use it to push notifications to this device
          if (token) {
            this.appToken = token;
            this.appCom.setLocalStorageItem("firebaseToken", { data: this.appToken });
          }
        }, function (error) {
          console.error(error);
        });
      }

      // set to landscape
      // this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);

      if (this.network.type !== 'none') {
        this.netConnection = true;
        this.shareService.setshareData('netConnection', this.netConnection);
      }
      else {
        const noInternet = await this.modalCtrl.create({
          component: NoInternetConnectionPage
        });
        await noInternet.present();
      }

      // if (this.platform.is('cordova')) {
        // this.appVersion.getVersionNumber().then((s) => {   //This comment so that build should be as per playstore policy
        this.appVersionNo = APP_VERSION;
        this.appCom.setLocalStorageItem("appversion", { data: this.appVersionNo });
        let device;
        if(this.appCom.platform.is('cordova')){
          device = this.appCom.platform.is('android') ? 'android' : 'ios';
        }else{
          device = 'web_app';
        }
        this.appCom.setLocalStorageItem("device", { data: device });
        // })
      // }

      // if (this.platform.is('cordova')) {
        // this.appVersion.getVersionCode().then((s) => { //This comment so that build should be as per playstore policy
        this.appCode = APP_CODE;
        console.log("app version code is: ", this.appCode);
        // })
      // }

      let disconnectSubscription = this.network.onDisconnect().subscribe(async () => {
        console.log('network was disconnected :-(');
        this.appCom.hideLoader();
        this.appCom.showToast(ALL_MESSAGE.ERROR_MESSAGE.NO_INTERNET, 1500);
        this.netConnection = false;
        this.shareService.setshareData('netConnection', this.netConnection);

        // const noInternet = await this.modalCtrl.create({
        //   component: NoInternetConnectionPage
        // });
        // await noInternet.present();
      });

      let connectSubscription = this.network.onConnect().subscribe(async () => {
        this.netConnection = true;
        this.modalCtrl.dismiss();
        this.checkAppUpdate();
        this.shareService.setshareData('netConnection', this.netConnection);
      });

      // if user id is stored, redirect to homepage
      this.appCom.getLocalStorageItem('userId').then((data: any) => {
        console.log('here 1', data);
        if (data && data.id > 0) {
          console.log('here 2');
          this.menu.enable(true);
          this.appCom.getLocalStorageItem("userData").then((data: any) => {
            if (data) {
              if(this.platform.is('cordova')){
                this.setupDeeplinks();
              }
              else{
                if(window.location.href.indexOf('?') >= 0 && window.location.search.length > 0)
                  this.setupDeeplinkPwa(
                    window.location.pathname,
                    window.location.search,
                    data.data.role.toLowerCase()
                  );
              }
              this.userData = data.data;
              this.userData['first_name'] = (this.userData['name']).split(" ")[0];
              if (!ALL_CONSTANTS.IS_STAGING) {
                // window.FirebasePlugin.setUserId(this.userData['userId']);
                // window.FirebasePlugin.setUserProperty("name", this.userData['name']);
                // window.FirebasePlugin.setUserProperty("region", this.userData['regionMapping']);
                // window.FirebasePlugin.setUserProperty("state", this.userData['stateMapping']);
                // window.FirebasePlugin.setUserProperty("city", this.userData['cityMapping']);
              }
              // refresh user's data on log in
              if (this.userData.role == "t2" || this.userData.role == "T2") {
                // this.getT2Data();  // to  refersh user data
                // this.checkForT3Role();
              } else {
                // this.getUserData();  // to  refersh user data
                // this.checkForT2Role();
              }
              // this.getUserRevision(); // to refersh user revision data
            }
          });
          console.log('Called @@@');
          if(this.appCom.platform.is('cordova'))
          this.router.navigateByUrl('/home').then(() => {
            setTimeout(() => {
              this.splashScreen.hide();
            }, 1000)
          });
        }
        else {
          console.log('here 3')
          this.router.navigateByUrl('/language-new').then(() => {
            this.splashScreen.hide();
          });
          //this.router.navigateByUrl('/bid-list');
        }
      }, error => {
        this.router.navigateByUrl('/language-new').then(() => {
          this.splashScreen.hide();
        });
        //this.router.navigateByUrl('/bid-list');
      });

      this.appCom.getLocalStorageItem("language").then((data: any) => {
        if (data && data.text != '') {
          this.currLan = data.text;
          this.translate.setDefaultLang(data.lang);
        }
        else {
          this.currLan = 'English';
          this.translate.setDefaultLang('en');
        }
      },
        (err) => {
          this.currLan = 'English';
          this.translate.setDefaultLang('en');
        });

      this.checkAppUpdate();

      this.backButtonEvent();
    });
  }

  checkAppUpdate() {
    let todayDate: any = new Date()
    let time = Math.floor(todayDate);

    this.getPostData.getDataFromApi(ALL_CONSTANTS.BASE_URL + '/update.json?v=' + time, {}).pipe(first())
      .subscribe(
        (data: any) => {

          if (data.t3_android.latest > this.appVersionNo) {
            this.showUpdateAlert(data.t3_android.url);
          }
          else {
            // update user's app access along with version, device and code
            if (this.userData && this.userData['userId']) {
              let device;
              if(this.appCom.platform.is('cordova')){
                device = this.appCom.platform.is('android') ? 'android' : 'ios';
              }else{
                device = 'web_app';
              }
              let user = { user_id: this.userData['userId'], appVersion: APP_VERSION, appCode: this.appCode, device: device, token: this.appToken ? this.appToken : '' };
              console.log(user);
              this.getPostData.postDataFromApiCustom(API_ENDPOINT.updateUserData, user).pipe(first())
                .subscribe(data => {
                  // updated
                });;
            }
          }


        },
        error => {
          console.log("aaaa");
        });

  }

  // get user's details once app is initialized to make sure user's data is refreshed.
  getUserData(val?) {
    console.log("called T3 usr data from appcomp.");
  }



  async showUpdateAlert(url) {
    this.updateUrl = url;
    this.showUpdate = true;
  }

  updateApp() {
    window.open(this.updateUrl, '_system');
    return false;
  }

  backButtonEvent() {
    this.platform.backButton.subscribeWithPriority(10, async () => {
      let backFlag = window.localStorage.getItem("saleBack");
      console.log("backFlag", backFlag);
      this.actionSheetController.getTop().then((res)=>{
        console.log("overlay",res);

      },err=>{
        console.log("overlay err",err);
      });
      try{
        this.actionSheetController.dismiss().then((res)=>{
          
          console.log("overlay dismiss",res);
        },err=>{
          console.log("overlay dismiss err",err);
        });
      }catch(err){
        console.log("Error on back",err);
      }

      // if(backFlag && backFlag == "allow"){
      //   this.router.navigate(['/sale-capture']);
      //   return false;
      // }
      // else 
      if (backFlag && backFlag == "disallow") {
        window.localStorage.setItem("saleBack", "allow");
        return false;
      }
      /** to understand if the user is logged in */
      await this.appCom.getLocalStorageItem('userId').then((data: any) => {
        if (data && data.id > 0) {
          this.userLoggedIn = true;
        }
        else {
          this.userLoggedIn = false;
        }
      },
        (err) => {
          this.userLoggedIn = false;
        });

      /** overwrite back on the basis of the cur page */
      this.currUrl = this.router.url;
      console.log("this.currUrl ", this.currUrl);
      console.log(this.currUrl, 'this current page', this.currUrl.indexOf("category-detail"));

      if (this.currUrl.indexOf("category-detail") == 1) {
        // this.router.navigate(['/category-list']);
        window.history.back();
        return false;
      }

      if (this.currUrl.indexOf("reward-brand") >= 0 || this.currUrl.indexOf("reward-catalogue-list") >= 0 || this.currUrl.indexOf("catalouge-detail") >= 0 || this.currUrl.indexOf("voucher-listing-detail") >= 0 || this.currUrl.indexOf("user-management-add") >= 0 || this.currUrl.indexOf("accessory-list") >= 0 || this.currUrl.indexOf("accessory-detail") >= 0 || this.currUrl.indexOf("product-request-detail") >= 0 || this.currUrl.indexOf("warranty-detail") >= 0 || this.currUrl.indexOf("product-detail") >= 0 || this.currUrl.indexOf("csr-activity-detail") >= 0) {
        // this.router.navigate(['/reward-catalogue']);
        window.history.back();
        return false;
      }
      if (this.currUrl.indexOf("sale-capture-add") >= 0 || this.currUrl.indexOf("sale-capture-detail") >= 0) {
        this.router.navigate(['/sale-capture']);
      }
      else if (this.currUrl.indexOf("scheme-detail") >= 0) {
        this.router.navigate(['/scheme']);
      }
      else if (this.currUrl.indexOf("services-detail") >= 0) {
        this.router.navigate(['/services']);
      }
      else if (this.currUrl.indexOf("bid-detail") >= 0) {
        this.router.navigate(['/bid-list']);
      }
      else if (this.currUrl.indexOf("whats-new-detail") >= 0) {
        this.router.navigate(['/whats-new']);
      }
      else if (this.currUrl.indexOf("query-detail") >= 0 || this.currUrl.indexOf("query-add") >= 0) {
        this.router.navigate(['/query']);
      }
      else if (this.currUrl.indexOf("inbox-detail") >= 0) {
        this.router.navigate(['/inbox']);
      }
      
      else if (this.currUrl.indexOf("performance-chart-t2-detail") >= 0) {
        this.location.back();
      }
      else if (this.currUrl.indexOf("profile") >= 0 || this.currUrl.indexOf("sale-capture") >= 0 || this.currUrl.indexOf("user-management") >= 0 || this.currUrl.indexOf("scheme") >= 0 || this.currUrl.indexOf("bid-list") >= 0 || this.currUrl.indexOf("whats-new") >= 0 || this.currUrl.indexOf("voucher-listing") >= 0 || this.currUrl.indexOf("product-request") >= 0 || this.currUrl.indexOf("videos") >= 0 || this.currUrl.indexOf("contact-matrix") >= 0 || this.currUrl.indexOf("rate-visit") >= 0 || this.currUrl.indexOf("query") >= 0 || this.currUrl.indexOf("reward") >= 0 || this.currUrl.indexOf("product-request-detail") >= 0 || this.currUrl.indexOf("category-list") >= 0 || this.currUrl.indexOf("performance-chart") >= 0) {
        this.router.navigate(['/home']);
        //this.events.publish('menu:pagechange', true, 'Home');
      }
      else if (this.currUrl.indexOf("language") >= 0) {
        // this.router.navigate(['/home',{cached:false}]);
        if (!this.userLoggedIn) {
          this.showExitPop();
        } else {
          window.history.back();
          return false;
        }
        console.log(this.userLoggedIn);
        console.log(this.currUrl);
        // window.history.back();
        // return false;
      } else if (this.currUrl.indexOf("terms") >= 0 && this.currUrl.indexOf('login') >= 0) {
        window.history.back();
        return false;
      }
      else if (this.currUrl.indexOf("category") >= 0 || this.currUrl.indexOf("accessory") >= 0 || this.currUrl.indexOf("warranty") >= 0 || this.currUrl.indexOf("search") >= 0) {
        this.router.navigate(['/category-list']);
      }
      else if (this.currUrl.indexOf("home") >= 0 || (this.currUrl == '/') || this.currUrl.indexOf("login") >= 0) {
        this.showExitPop();
      } else if (this.currUrl.indexOf("intro-slides") >= 0) {

        this.router.navigate(['/language-new']);
      } else if (this.currUrl.indexOf("greetings") >= 0) {

        this.router.navigate(['/greeting-listing']);
      }
      else if (this.userLoggedIn) {
        this.router.navigate(['/home']);
      }
      else {
        this.showExitPop();
      }
    });
  }

  async showExitPop() {
    if (this.confirmPopOpen) {
      return false;
    }
    let yes = 'YES';
    let no = 'NO';
    this.translate.get(yes).subscribe((data) => {
      yes = data;
    }, (error) => {
    });
    this.translate.get(no).subscribe((data) => {
      no = data;
    }, (error) => {
    });
    this.confirm = await this.alertCtrl.create({
      header: 'Exit Application',
      subHeader: 'Are you sure you want to exit the app?',
      cssClass: 'alertionic-pop',
      buttons: [
        {
          text: yes,
          handler: () => {
            this.confirmPopOpen = false;
            navigator['app'].exitApp();
          }
        },
        {
          text: no,
          handler: () => {
            this.confirmPopOpen = false;
            console.log('Disagree clicked');
          }
        }
      ]
    });
    await this.confirm.present();
    this.confirmPopOpen = true;
  }

  goToProfile() {
    this.menu.toggle();
    if (this.auth.menuArray.indexOf('/profile') >= 0)
      this.router.navigate(["/profile"]);
    else if (this.auth.menuArray.indexOf('/profile-srd') >= 0)
      this.router.navigate(["/profile-srd"]);
    // this.router.navigate(['/profile']);
  }

  async logout() {
    let saleStatusSel = 'All';
    let confirmTxt = 'Confirm Logout';
    let confirmQues = 'Are you sure you want to logout?';
    let yes = 'YES';
    let no = 'NO';
    this.translate.get(confirmTxt).subscribe((data) => {
      confirmTxt = data;
    }, (error) => {
    });
    this.translate.get(confirmQues).subscribe((data) => {
      confirmQues = data;
    }, (error) => {
    });
    this.translate.get(yes).subscribe((data) => {
      yes = data;
    }, (error) => {
    });
    this.translate.get(no).subscribe((data) => {
      no = data;
    }, (error) => {
    });
    let logout = await this.alertCtrl.create({
      header: confirmTxt,
      cssClass: 'exit-pop',
      subHeader: confirmQues,
      buttons: [
        {
          text: yes,
          handler: () => {
            this.menu.enable(false);
            this.appCom.moengageUserLogout.next(true);
            this.appCom.getLocalStorageItem("userData").then((data: any) => {
              if (data.data) {
                this.userData = data.data;
                this.userData['first_name'] = (this.userData['name']).split(" ")[0];
                if (!ALL_CONSTANTS.IS_STAGING) {
                  ///window.FirebasePlugin.logEvent("logout", { user: this.userData['mobile'] });
                  this.firebaseAnalytics.logEvent('page_view', { page: 'Logout - '+this.userData.role.toLowerCase(), item_id: "Logout" });
                }
              } else {
                this.userData = {};
              }
            });
            this.showRoleSwitch = false;
            // clear storage
            this.removeAllPossibleKeys("pendingVisits");
            this.auth.menuArray = [];
            this.nativeStorage.clear();
            // window.localStorage.clear();
            this.removeDataFromStorage();


            this.router.navigate(['/login']);
          }
        },
        {
          text: no,
          handler: () => {
            console.log('Disagree clicked');
          }
        }
      ]
    });
    this.menu.toggle();
    await logout.present();
  }

  removeDataFromStorage() {
    let roles = ['userData', 'otherRoleMenuArray', 'userId', 'roleBaseConfig', 'homepop666760', 'menuArray', 'MOENGAGE_REGISTER', 'device', 'services', 'userRoleBaseData', 'mainContentTrainig'+this.userData.role.toLocaleLowerCase(), 'trainingCradPop', 'gaminingCardPop', 'reward_brands', 'session_timing', 'active_voucher', 'reward_category', 'MenuUpdatedOn', 'getAppMenuListResponse' ];
    roles.forEach(element => {
      window.localStorage.removeItem(element);
    });
  }

  getT2Data(val?) {
    return new Promise((res, rej) => {

      // this.getPostData.getDataFromApi(API_ENDPOINT.getT3T2Data, { uid: this.userData.userId, t2_uid: this.userData.userId }).then((data: any) => {
      //   if (data && data.length > 0) {
      //     /** If rate pop for this was closed/not, show rating pop accordingly */
      //     this.formatUserData(data[0], "t2", val);
      //     res(true);
      //   }
      // })

      this.getPostData.getDataFromApi(API_ENDPOINT.getT3T2Data, { uid: this.userData.userId, t2_uid: this.userData.userId }).pipe(first()).subscribe((data: any) => {
        if (data && data.length > 0) {

          /** If rate pop for this was closed/not, show rating pop accordingly */
          this.formatUserData(data[0], "t2", val);
          res(true);
        }
      })

    });
  }

  formatUserData(data, searchedUserRole, val?) {
    return new Promise((res, rej) => {
      if (data) {
        let fullNameSel = data.field_name;
        let emailIdSel = data.mail;
        let companyNameSel = data.field_company_name;
        let companyAddressSel = data.field_company_address;
        let pincodeSel = data.field_pincode;
        let gstnNoSel = data.field_gstn_number;
        let birthDateSel = data.field_date_of_birth;
        let anniversaryDateSel = data.field_anniversary_date;
        let dateOfIncorporationSel = data.field_date_of_incorporation;
        let prioritySel = data.field_type_of_business;
        let photo = "";
        let pancardStatus = "";
        let call_details = "";
        let aso_status = "";
        let t2UserType = "";
        let taggedT3 = "";
        let pancardImg = "";
        let sales = "";
        let rebates = "";
        let doYouSell = "";
        let focus_category = "";
        let sub_category = "";
        let hp = "";
        let lenovo = "";
        let dell = "";
        let others = "";

        if (anniversaryDateSel == '' || anniversaryDateSel == '1970-01-01') {
          anniversaryDateSel = '';
        }

        if (dateOfIncorporationSel == '' || dateOfIncorporationSel == '1970-01-01') {
          dateOfIncorporationSel = '';
        }

        let stateSel = data.state;
        let citySel = data.city;

        if ((data.user_picture) && (data.user_picture).length > 0) {
          photo = ALL_CONSTANTS.BASE_URL + '/' + data.user_picture;
        }
        let profileStatus = data.field_profile_verification_statu;

        let manage_user_type = data.field_user_type;
        let manage_owner_id = data.owner_id;

        // if pan image is uploaded
        if (data.field_pancard_image && data.field_pancard_image != '') {
          pancardImg = ALL_CONSTANTS.BASE_URL + '/' + data.field_pancard_image;
        }
        console.log(data.pan_image, data, 'data profile');


        if (!data.pan_apprfield_pancard_approvaloval) {
          pancardStatus = "Pending";
        }
        else {
          pancardStatus = data.field_pancard_approval;
        }


        let pan_rejection_reason = data.field_pan_rejection_reason;

        // if this user is verified on the call by the lenovo team
        if (data.field_call_details) {
          call_details = data.field_call_details;
        }
        let call_verification = data.field_call_verification;
        let call_verification_date = data.field_call_verification_date;

        if (data.field_aso_status) {
          aso_status = data.field_aso_status;
        }

        //this is for checking T2 user type
        if (data.field_t2_type) {
          t2UserType = data.field_t2_type;
        }

        //this is for checking Tagged T3 user
        if (data.field_t3_user) {
          taggedT3 = data.field_t3_user;
        }

        this.appCom.setLocalStorageItem('userId', { id: data.uid });

        var birthDate: any = new Date(birthDateSel);
        birthDate = birthDate.getFullYear() + "-" + (birthDate.getMonth() + 1) + "-" + birthDate.getDate();

        var anniversaryDate: any = new Date(anniversaryDateSel);
        anniversaryDate = anniversaryDate.getFullYear() + "-" + (anniversaryDate.getMonth() + 1) + "-" + anniversaryDate.getDate();

        var date_of_incorporation: any = new Date(dateOfIncorporationSel);
        date_of_incorporation = date_of_incorporation.getFullYear() + "-" + (date_of_incorporation.getMonth() + 1) + "-" + date_of_incorporation.getDate();

        let totalPoints = 0;
        let totalRedeemedPoints = 0;
        let estimated_point = 0;

        if (searchedUserRole == 't2') {
          totalPoints = data.t2_total_points ? data.t2_total_points : 0;
          totalRedeemedPoints = data.t2_redeemed_points ? data.t2_redeemed_points : 0;
          estimated_point = data.t2_estimated_points ? data.t2_estimated_points : 0;
          data.currentPoints = totalPoints - totalRedeemedPoints;
        } else {
          totalPoints = data.field_total_points ? data.field_total_points : 0;
          totalRedeemedPoints = data.field_total_redeem_point ? data.field_total_redeem_point : 0;
          estimated_point = data.field_estimated_point ? data.field_estimated_point : 0;
          data.currentPoints = totalPoints - totalRedeemedPoints;
        }
        data.roles_target_id = data.roles_target_id ? (data.roles_target_id).toLowerCase() : "";

        if (searchedUserRole == "t3") {
          data.field_user_type = (data['field_user_type']).toLowerCase();
          if (data.field_user_type != 'employee' && data.field_user_type != 'coowner') {
            data.roles_target_id = data.roles_target_id;
          }
          else if (data.field_user_type == 'employee') {
            data.roles_target_id = 'Employee';
          }
          else if (data.field_user_type == 'coowner') {
            data.roles_target_id = 'Co-Owner';
          }
        }
        let shopId = "";
        if (searchedUserRole == 't2') {
          if (data.field_t2_shop_details) {
            shopId = data.field_t2_shop_details;
          }
        } else {
          if (data.shop_id) {
            shopId = data.shop_id;
          }
        }

        if (searchedUserRole == 't2') {
          if (data['field_customer_s_focus_category']) {
            focus_category = data['field_customer_s_focus_category'];
          }

          if (data['field_customer_s_sub_category_']) {
            sub_category = data['field_customer_s_sub_category_'];
          }

          if (data['field_do_you_have_any_rebates_or']) {
            rebates = data['field_do_you_have_any_rebates_or'];
          }

          if (data['field_do_you_sell']) {
            doYouSell = data['field_do_you_sell'];
          }

          if (data['field_number_of_sales_persons']) {
            sales = data['field_number_of_sales_persons'];
          }

          if (data['field_dell']) {
            dell = data['field_dell'];
          }

          if (data['field_lenovo']) {
            lenovo = data['field_lenovo'];
          }

          if (data['field_others']) {
            others = data['field_others'];
          }

          if (data['field_hp']) {
            hp = data['field_hp'];
          }
        }


        let userData = {
          'name': fullNameSel, 'company_name': companyNameSel, 'company_address': companyAddressSel, 'pincode': pincodeSel, 'email': emailIdSel, 'gstn_no': gstnNoSel, 'referral_code': '', 'userId': data.uid, 'role': data.roles_target_id, 'mobile': data.field_mobile_number, "cityName": data.field_city, "stateName": data.field_state, "city": data.city_id, "state": data.state_id, "points": totalPoints, "estimated_point": estimated_point, 'newProfile': 0, 'photo': photo, 'priority': prioritySel, 'profileStatus': profileStatus, 'pan_image': pancardImg, 'pan_status': pancardStatus, 'pan_rejection_reason': pan_rejection_reason, 'call_details': call_details, 'call_status': call_verification, 'call_verified_on': call_verification_date, 'aso_status': aso_status, 'birth_date': birthDate, 'anniversary_date': anniversaryDate, 'date_of_incorporation': date_of_incorporation,
          'regionMapping': data.regionMapping ? data.regionMapping : data.field_region, 'stateMapping': data.stateMapping, 'cityMapping': data.cityMapping, 'manage_user_type': manage_user_type, 'manage_owner_id': manage_owner_id, "currentPoints": data.currentPoints, "redeemed_points": totalRedeemedPoints, 'type_of_business': data.field_type_of_business, "t2_user_type": t2UserType, "t3_user_tagged": taggedT3, 'certificate': data.field_certificate, 'revision_id': data.revision_id, 'shop_id': shopId, 'field_profile_changed': data.field_profile_changed, "field_customer_s_focus_category": focus_category,
          "field_customer_s_sub_category_": sub_category,
          "field_number_of_sales_persons": sales,
          "field_do_you_sell": doYouSell,
          "field_do_you_have_any_rebates_or": rebates,
          "field_lenovo": lenovo,
          "field_hp": hp,
          "field_dell": dell,
          "field_others": others,
        };
        if(this.appCom.platform.is('cordova'))
        this._moengage.registerForPush(userData);

        // this.appCom.setLocalStorageItem("userData", { data: userData });
        if (val && val != 'updateSwitch') {
          window.localStorage.removeItem("MenuUpdatedOn");
          this.events.publish("userUpdated", true, searchedUserRole, this.popPage);
          this.popPage = false;
          this.setSwitcher();
        } else if (val == 'updateSwitch') {
          this.setSwitcher();
        }
      }

    });
  }

  updateUserData(val?) {
    console.log("called update data val", val);
    this.appCom.getLocalStorageItem("userData").then((data: any) => {
      if (data) {
        console.log("userdata", data.data);
        this.userData = data.data;
        this.userData['first_name'] = (this.userData['name']).split(" ")[0];
        if (this.userData.role != "t2" && this.userData.role != "T2") {
          console.log("called update data ", this.userData.role)
          this.getUserData(val);  // to  refersh user data 
        } else {
          this.getT2Data(val);  // to  refersh user data
        }
      }
    });
  }

  // async roleChange() {

  //   this.showFooter = false;
  //   if (this.currentRole == "t3") {
  //     //check if t3Data is stored or not before changing data to T2
  //     this.appCom.getLocalStorageItem("t3UserData").then(async (data:any) => {
  //       if (data.data) {
  //         await this.appCom.getLocalStorageItem("t2UserData").then(async (data:any) => {
  //           if (data.data) {
  //             this.t2UserData = data;
  //             this.appCom.setLocalStorageItem("userData", data);

  //             this.appCom.setLocalStorageItem('userId', { id: data.data.userId });

  //             this.updateUserData(true);
  //             this.currentRole = this.selectedRole;
  //             this.showFooter = true;
  //             this.appCom.brochureCall.next(true);
  //           }
  //         },
  //           (err) => {
  //             console.log('err', err);
  //           })
  //       } else {
  //         console.log("No data found for T3");
  //         this.saveT3DataFirst();
  //       }
  //     },
  //       (err) => {
  //         if (!err.exception) {
  //           console.log("No data found for T3 err");
  //           this.saveT3DataFirst();
  //         }
  //         console.log('err', err);
  //       });

  //   } else if (this.currentRole == "t2") {
  //     //check if t3Data is stored or not before changing data to T2
  //     console.log("Checking if")
  //     await this.nativeStorage.getItem("t2UserData").then(async data => {
  //       if (data.data) {
  //         await this.nativeStorage.getItem("t3UserData").then(async data => {
  //           if (data.data) {
  //             this.t3UserData = data;
  //             this.nativeStorage.setItem("userData", data);
  //             window.localStorage.setItem("userData", JSON.stringify(data));

  //             this.nativeStorage.setItem('userId', { id: data.data.userId });
  //             window.localStorage.setItem('userId', JSON.stringify({ id: data.data.userId }))
  //             this.updateUserData(true)
  //             this.currentRole = this.selectedRole;
  //             this.showFooter = true;
  //             this.appCom.brochureCall.next(true);
  //           }
  //         },
  //           (err) => {
  //             console.log('err', err);
  //           })
  //       } else {
  //         this.saveT2DataFirst();
  //       }
  //     },
  //       (err) => {
  //         if (!err.exception) {
  //           this.saveT2DataFirst();
  //         }
  //         console.log('err', err);
  //       });

  //   }



  // }

  async roleChangeDynamic(userId?, internalLink?, switchRole?) {
    if(!userId){
      return;
    }
    return this.getPostData.postDataFromApiCustom(API_ENDPOINT.fetchUserDetails, { 'user_id': userId }).subscribe(async (resData: any) => {
      let data = resData;

      if (data.profileDetails) {
      }

      console.log("data", data.profileDetails.profileVerified);

      // if profile is not verified, show all the fields
      if (data.profileDetails.profileVerified == 0) {
        // this.showProfile = true;
      }
      // if profile is already verified, throw him on homepage
      else if (data.profileDetails.profileVerified == 1) {
        this.appCom.setLocalStorageItem('userId', { id: data.user_id });
        this.menu.enable(true);
        // , 


        let totalPoints = data.profileDetails.points ? data.profileDetails.points : 0;
        let totalRedeemedPoints = data.profileDetails.field_total_redeem_point ? data.profileDetails.field_total_redeem_point : 0;
        data.currentPoints = totalPoints - totalRedeemedPoints;

        var birthDate: any = new Date(data.profileDetails.birth_date);
        birthDate = "2000-" + (birthDate.getMonth() + 1) + "-" + birthDate.getDate();

        var anniversaryDate: any = new Date(data.profileDetails.anniversary_date);
        anniversaryDate = "2000-" + (anniversaryDate.getMonth() + 1) + "-" + anniversaryDate.getDate();

        var date_of_incorporation: any = new Date(data.profileDetails.date_of_incorporation);
        date_of_incorporation = date_of_incorporation.getFullYear() + "-" + (date_of_incorporation.getMonth() + 1) + "-" + date_of_incorporation.getDate();

        let userData = {
          'name': data.profileDetails.name, 'company_name': data.profileDetails.company_name, 'company_address': data.profileDetails.company_address, 'pincode': data.profileDetails.pincode, 'email': data.profileDetails.email, 'gstn_no': data.profileDetails.gstn_no, 'referral_code': data.profileDetails.referral_code, 'userId': data.userId, 'role': data.userRole, 'mobile': data.profileDetails.mobile, "cityName": data.profileDetails.cityName, "stateName": data.profileDetails.stateName, "city": data.profileDetails.city, "state": data.profileDetails.state, "points": data.profileDetails.points, "estimated_point": data.profileDetails.field_estimated_point, "picture": data.profileDetails.photo, "photo": data.profileDetails.photo, 'priority': data.profileDetails.field_type_of_business, 'profileStatus': data.profileDetails.profile_status, 'pan_image': data.profileDetails.pan_image ? data.profileDetails.pan_image : null, 'pan_status': data.profileDetails.pan_approval ? this.appCom.titleCase(data.profileDetails.pan_approval) : 'Pending', 'pan_rejection_reason': data.profileDetails.pan_rejection_reason, 'pan_number': data.profileDetails.pan_number, 'newProfile': 0, 'region': data.profileDetails.region, 'territory': data.profileDetails.territory, 'rcm': data.profileDetails.rcm, 'rsm': data.profileDetails.rsm, 'aso_type': data.profileDetails.field_type_of_aso, 't3_user_tagged': data.profileDetails.field_t3_user, 'call_details': data.profileDetails.call_details ? data.profileDetails.call_details : null, 'call_status': this.appCom.titleCase(data.profileDetails.call_verification), 'call_verified_on': data.profileDetails.call_verification_date, 'aso_status': data.profileDetails.aso_status ? this.appCom.titleCase(data.profileDetails.aso_status) : null, 'birth_date': birthDate, 'anniversary_date': anniversaryDate, 'regionMapping': data.profileDetails.regionMapping, 'stateMapping': data.profileDetails.stateMapping, 'cityMapping': data.profileDetails.cityMapping, "gst_validated": data.profileDetails.gst_approved, 'date_of_incorporation': date_of_incorporation, 'manage_user_type': data.profileDetails.user_type, 'manage_owner_id': data.profileDetails.owner_id, "currentPoints": data.currentPoints, "redeemed_points": data.profileDetails.field_total_redeem_point, 'type_of_business': data.profileDetails.field_type_of_business, "t2_user_type": data.profileDetails.field_t2_type ? data.profileDetails.field_t2_type : null, "field_customer_s_focus_category": data.profileDetails['field_customer_s_focus_category'],
          "field_customer_s_sub_category_": data.profileDetails['field_customer_s_focus_category'],
          "field_number_of_sales_persons": data.profileDetails['field_number_of_sales_persons'],
          "field_do_you_sell": data.profileDetails['field_do_you_sell'] ? (data.profileDetails['field_do_you_sell']).join(",") : null,
          "field_do_you_have_any_rebates_or": data.profileDetails['field_do_you_have_any_rebates_or'] ? (data.profileDetails['field_do_you_have_any_rebates_or']).join(",") : null,
          "field_lenovo": data.profileDetails['field_lenovo'],
          "field_hp": data.profileDetails['field_hp'],
          "field_dell": data.profileDetails['field_dell'],
          "field_others": data.profileDetails['field_others'],
          "t2_shopId": data.profileDetails.t2_shop ? data.profileDetails.t2_shop : '',
          'shop_id': data.profileDetails.shop_id, 'field_profile_changed': data.profileDetails.field_profile_changed, 'call_verification_date' : data.profileDetails.call_verification_date, 'gst_verification_date' : data.profileDetails.gst_verified_on,
          'pan_verification_date' : data.profileDetails.pan_verified_on,
          'update_ref_id': data.profileDetails.update_ref_id,
          'owner_mail' : data.profileDetails.owner_mail
        };

        await this.appCom.setLocalStorageItem("userData", { data: userData })
        this.appCom.setLocalStorageItem('userId', { id: data.userId });
        this.appCom.setLocalStorageItem("userRoleBaseData", resData.userRoleBasedData.userRolesConfiguration); // will store role which have permission
        // this._moengage.registerForPush(userData);
        this.events.publish('user:loggedin', true, Date.now());

        this.appCom.showFooterSub.next(true);
        console.log('this.page : ', this.popPage)
        this.appCom.brochureCall.next(true);
        this.events.publish("userUpdated", true, data.profileDetails.role, this.popPage ? this.popPage : '/home');
        if (internalLink) {
          this.getAppPages(userData, internalLink);
        }
        else if (switchRole) {
          window.localStorage.removeItem("MenuUpdatedOn");
          this.auth.menuArray = [];
          this.getAppPages(userData);
        }
        this.popPage = false;
        this.setSwitcher();
      }
    },
      err => {

      });
  }

  checkForOtherRoles() {
    // this.showRoleSwitch = false;
    this.activateNewRole = false;
    if (this.currentRole == "t3") {
      this.checkForT2Role();
    } else if (this.currentRole == "t2") {
      // this.checkForT3Role();
    }
  }

  async checkForT2Role() {
    // await this.appcom.showLoader();
    return new Promise((res, rej) => {
      // this.getPostData.getDataFromApi(API_ENDPOINT.getTaggedT2Users, { t3_user: this.userData.userId, t2_number: this.userData.mobile }).then((data: any) => {
      //   if (data && data.length > 0) {
      //     /** If rate pop for this was closed/not, show rating pop accordingly */
      //     this.appCom.formatUserData(data[0], "t2", this.userData);
      //     console.log("I have T2 role also")
      //     this.showRoleSwitch = true;
      //     this.activateNewRole = false;
      //     this.setSwitcher();
      //     this.activateRole();
      //     res(true);
      //   } else {
      //     if (this.userData.manage_user_type == 'owner' || this.userData.manage_user_type == 'Owner') {
      //       this.activateNewRole = true;
      //     }
      //     this.activateRole();
      //     this.setSwitcher();
      //     res(true);
      //   }
      // })

      this.getPostData.getDataFromApi(API_ENDPOINT.getTaggedT2Users, { t3_user: this.userData.userId, t2_number: this.userData.mobile }).pipe(first()).subscribe((data: any) => {
        if (data && data.length > 0) {
          /** If rate pop for this was closed/not, show rating pop accordingly */
          this.appCom.formatUserData(data[0], "t2", this.userData);
          console.log("I have T2 role also")
          this.showRoleSwitch = true;
          this.activateNewRole = false;
          this.setSwitcher();
          this.activateRole();
          res(true);
        } else {
          if (this.userData.manage_user_type == 'owner' || this.userData.manage_user_type == 'Owner') {
            this.activateNewRole = true;
          }
          this.activateRole();
          this.setSwitcher();
          res(true);
        }
      })

    });
  }

  // async checkForT3Role() {
  //   // this.showRoleSwitch =true;
  //   // await this.appcom.showLoader();
  //   return new Promise((res, rej) => {
  //     // this.getPostData.getDataFromApi(API_ENDPOINT.getTaggedT3Users, { uid: this.userData.userId }).then((data: any) => {
  //     //   if (data && data.length > 0) {
  //     //     /** If rate pop for this was closed/not, show rating pop accordingly */
  //     //     this.appCom.formatUserData(data[0], "t3", this.userData);
  //     //     console.log("I have T3 role also");
  //     //     this.showRoleSwitch = true;
  //     //     this.activateNewRole = false;
  //     //     this.activateRole();
  //     //     this.setSwitcher();
  //     //     res(true);
  //     //   } else {
  //     //     console.log("I Dont have T3 role", this.userData.manage_user_type);
  //     //     console.log("I Dont have T3 role", this.userData);
  //     //     if (this.userData.manage_user_type == 'owner' || this.userData.manage_user_type == 'Owner') {
  //     //       this.activateNewRole = true;
  //     //     }
  //     //     console.log("I Dont have T3 role activateNewRole", this.activateNewRole);
  //     //     this.showRoleSwitch = false;
  //     //     this.activateRole();
  //     //     this.setSwitcher();
  //     //     console.log("changed app", this.activateNewRole);
  //     //     res(true);
  //     //   }
  //     // })

  //     this.getPostData.getDataFromApi(API_ENDPOINT.getTaggedT3Users, { uid: this.userData.userId }).pipe(first()).subscribe((data: any) => {
  //       if (data && data.length > 0) {
  //         /** If rate pop for this was closed/not, show rating pop accordingly */
  //         this.appCom.formatUserData(data[0], "t3", this.userData);
  //         console.log("I have T3 role also");
  //         this.showRoleSwitch = true;
  //         this.activateNewRole = false;
  //         this.activateRole();
  //         this.setSwitcher();
  //         res(true);
  //       } else {
  //         console.log("I Dont have T3 role", this.userData.manage_user_type);
  //         console.log("I Dont have T3 role", this.userData);
  //         if (this.userData.manage_user_type == 'owner' || this.userData.manage_user_type == 'Owner') {
  //           this.activateNewRole = true;
  //         }
  //         console.log("I Dont have T3 role activateNewRole", this.activateNewRole);
  //         this.showRoleSwitch = false;
  //         this.activateRole();
  //         this.setSwitcher();
  //         console.log("changed app", this.activateNewRole);
  //         res(true);
  //       }
  //     })

  //   });
  // }

  async activateRole(role?) {
    console.log("changed app activateRole");
    this.appPages.forEach(element => {
      if (this.activateNewRole == true) {
        if (element.url) {
          if (element.url == "/activate-role") {
            if (this.userData.role == 't3' || this.userData.role == 'T3' || this.userData.role == 'Lenovo Partner' || this.userData.role == 'lenovo partner') {
              element.title = 'Activate LEMB';
              this.translate.get(element.title).subscribe((data) => {
                element.title = data;
              }, (error) => {
              });
              element.status = this.activateNewRole;
            } else if (this.userData.role == 'T2' || this.userData.role == 't2') {
              element.title = 'Activate SOSB';
              this.translate.get(element.title).subscribe((data) => {
                element.title = data;
              }, (error) => {
              });
              element.status = this.activateNewRole;
            }

          }
        }
      } else if (this.activateNewRole == false) {
        if (element.url == "/activate-role") {
          element.status = this.activateNewRole;
        }
      }
    });
    console.log("changed app", this.activateNewRole);
    console.log("changed app", this.appPages);
  }
  setSwitcher() {
    this.appPages.forEach((element: any) => {
      if (element.url) {

        if (element.url == "/switch") {

          // if (this.userData.role == 't2' || this.userData.role == 'T2') {
          //   element.title = 'switch-to-t3';
          // } else {
          //   element.title = 'switch-to-t2';
          // }

          // this.getPostData.getLabelFromJson().subscribe((res) => {
          //   console.log('Label of : ', res);
          //   // this.labelName = res;
          //   element.title = 'Switch to ' + element.name;
          //   element.status = this.showRoleSwitch;
          //   if (this.showRoleSwitch) {
          //     this.activateNewRole = false;
          //   }
          // }, err => {
          //   console.log('err = : ', err);
          // })



        }

      } else if (element.title == "My Business") {

        if (element.children) {

          element.children.forEach(child => {

            if (child.url == '/rate-visit') {

              if (this.userData.role == 't2' || this.userData.role == 'T2') {
                child.title = 'CPM Visits';
                if (this.router.url == '/rate-visit') {
                  this.currPage = 'CPM Visits';
                }
              } else {
                child.title = 'ASO Visits';
                if (this.router.url == '/rate-visit') {
                  this.currPage = 'ASO Visits';
                }
              }

            }

          });
        }
      }
    });
    console.log("CHanted menu ", this.appPages);
  }

  removeAllPossibleKeys(key, value?) {

    let roles = ['t2', 'T2', 't3', 'T3', 'lenovo partner', 'Lenovo Partner'];
    roles.forEach(element => {
      this.nativeStorage.remove(key + element);
    });
  }

  setupDeeplinks() {
    let config: Route[] = this.router.config;
    let paths = {};
    for (let index = 0; index < config.length; index++) {
      let path = "";
      const route = config[index];
      path = "/" + route.path;
      paths[path] = path;
      // path = "/#/" + route.path;
      // paths[path] = path;
      // path = "/#" + route.path;
      // paths[path] = path;
      // path = "#/" + route.path;
      // paths[path] = path;

    }

    this.appCom.moengageNotificationClicked.subscribe((res) => {
      console.log('MOengage appCom : ', res
      )
      res && this.navigateForDeeplink(res)
    });

    console.log('Paths @@@ :', paths);

    this._deeplink.route(paths).subscribe(
      (match) => {
        console.log(match);
        let internalLink: any = "";
        if (Object.keys(match.$args).length > 0) {
          console.log('match.$args : ', match.$args)
          let queryParams = {};
          Object.keys(match.$args).forEach((ele) => {
            queryParams[ele] = match.$args[ele];
          });
          internalLink = [match.$route, queryParams];
          console.log('Query Param :', internalLink)
          this.navigateForDeeplink(internalLink)
        } else {
          console.log('else : ')
          internalLink = [match.$route];
          this.navigateForDeeplink(internalLink)
        }

        console.log(JSON.stringify(match));

      },
      (nomatch) => {
        console.log("Got a deeplink that didn't match - " + JSON.stringify(nomatch));
      }
    );
  }

  fetchRoleBaseDetailForSwicth(internalLink) {
    this.appCom.getLocalStorageItem('otherRoleMenuArray').then((otherRoleMenu: any) => {
      console.log('other Menu : ', otherRoleMenu)
      otherRoleMenu.filter(item => {
        item.menu_list.filter(item1 => {
          console.log('data in loop : ', internalLink[0], item1.route)
          if (internalLink[0] == item1.route) {
            this.roleChangeDynamic(item.userID, internalLink);
          }
        })
      });
    })
  }

  navigateForDeeplink(internalLink) {
    console.log('Internal Link : ',internalLink);
    this._ngZone.run(() => {
      // this.router.navigate([match.$route, { nid: match.$args["nid"] }]);
      this.appCom.getLocalStorageItem('userData').then((userData: any) => {
        var usData = userData.data.aso_type;

        console.log("Link @@ :", internalLink[1], userData);
        if (internalLink[1].role == userData.data.role.toLowerCase()) {
          if(internalLink[1].aso_type && internalLink[1].aso_type == userData.data.aso_type.toLowerCase()){
            this.goToPageUsingDeeplink(internalLink, userData);
          }
          else if(internalLink[1].aso_type && internalLink[1].aso_type != userData.data.aso_type.toLowerCase()){
            this.appCom.getLocalStorageItem('otherRoleMenuArray').then((otherRoleMenu: any) => {
              console.log('other Menu : ', otherRoleMenu)
              otherRoleMenu.filter(item => {
                if (item.asoType.toLowerCase() == internalLink[1].aso_type) {
                  item.menu_list.filter(item1 => {
                    // console.log('data in loop : ', internalLink[0], item1.route)
                    if (internalLink[0] == item1.route) {
                      this.roleChangeDynamic(item.userID, internalLink);
                    }
                  })
                }
  
              });
            })
          }
          else{
            this.goToPageUsingDeeplink(internalLink, userData);
          }
        }
        else {
          this.appCom.getLocalStorageItem('otherRoleMenuArray').then((otherRoleMenu: any) => {
            console.log('other Menu : ', otherRoleMenu)
            otherRoleMenu.filter(item => {
              if (item.userRole.toLowerCase() == internalLink[1].role) {
                item.menu_list.filter(item1 => {
                  console.log('data in loop : ', internalLink[0], item1.route)
                  if (internalLink[0] == item1.route) {
                    this.roleChangeDynamic(item.userID, internalLink);
                  }
                })
              }

            });
          })
        }

        // this.router.navigate(internalLink);

      });
    });
  }


  goToPageUsingDeeplink(internalLink, userData) {
    if (internalLink[0] == '/sale-capture') {
      if (this.userData.aso_type == 't2' || this.userData.aso_type == 'T2') {

        this.currentRole = 't2';
        this.selectedRole = 't3';
        this.fetchRoleBaseDetailForSwicth(internalLink);
      }
      else {
        this.getAppPages(userData.data, internalLink)
        // this.router.navigate(internalLink);
      }
    }
    else if (internalLink[0] == '/sales-capture-t2') {
      if (this.userData.role == 'Lenovo Partner' || this.userData.role == 'lenovo partner') {
        this.currentRole = 't3';
        this.selectedRole = 't2';
        // this.roleChange().then(() => {
        //   this.router.navigate(internalLink);
        // });
        this.fetchRoleBaseDetailForSwicth(internalLink)
      }
      else {
        this.getAppPages(userData.data, internalLink)
        // this.router.navigate(internalLink);
      }
    }
    else if (internalLink[0] == '/sale-capture-detail') {
      if (this.userData.role == 't2' || this.userData.role == 'T2') {
        this.currentRole = 't2';
        this.selectedRole = 't3';
        // this.roleChange().then(() => {
        //   this.router.navigate(internalLink);
        // });
        this.fetchRoleBaseDetailForSwicth(internalLink)
      }
      else {
        this.getAppPages(userData.data, internalLink)
        // this.router.navigate(internalLink);
      }
    }
    else if (internalLink[0] == '/sales-capture-t2-detail') {
      if (this.userData.role == 'Lenovo Partner' || this.userData.role == 'lenovo partner') {
        this.currentRole = 't3';
        this.selectedRole = 't2';
        // this.roleChange().then(() => {
        //   this.router.navigate(internalLink);
        // });
        this.fetchRoleBaseDetailForSwicth(internalLink)
      }
      else {
        this.getAppPages(userData.data, internalLink)
        // this.router.navigate(internalLink);
      }
    }
    else if (internalLink[0] == '/performance-chart-t2') {
      if (this.userData.role == 'Lenovo Partner' || this.userData.role == 'lenovo partner') {
        this.currentRole = 't3';
        this.selectedRole = 't2';
        // this.roleChange().then(() => {
        //   this.router.navigate(internalLink);
        // });
        this.fetchRoleBaseDetailForSwicth(internalLink)
      }
      else {
        this.getAppPages(userData.data, internalLink)
        // this.router.navigate(internalLink);
      }
    }
    else if (internalLink[0] == '/user-management-t2') {
      if (this.userData.role == 'Lenovo Partner' || this.userData.role == 'lenovo partner') {
        this.currentRole = 't3';
        this.selectedRole = 't2';
        // this.roleChange().then(() => {
        //   this.router.navigate(internalLink);
        // });
        this.fetchRoleBaseDetailForSwicth(internalLink)
      }
      else {
        this.getAppPages(userData.data, internalLink)
        // this.router.navigate(internalLink);
      }
    }
    else if (internalLink[0] == '/user-management') {
      if (this.userData.role == 't2' || this.userData.role == 'T2') {
        this.currentRole = 't2';
        this.selectedRole = 't3';
        // this.roleChange().then(() => {
        //   this.router.navigate(internalLink);
        // });
        this.fetchRoleBaseDetailForSwicth(internalLink)
      }
      else {
        this.getAppPages(userData.data, internalLink)
        // this.router.navigate(internalLink);
      }
    }
    else if (internalLink[0] == '/query-detail') {
      if (this.userData.role == 't2' || this.userData.role == 'T2') {
        this.currentRole = 't2';
        this.selectedRole = 't3';
        // this.roleChange().then(() => {
        //   this.router.navigate(internalLink);
        // });
        this.fetchRoleBaseDetailForSwicth(internalLink)
      }
      else {
        this.getAppPages(userData.data, internalLink)
        // this.router.navigate(internalLink);
      }
    }
    else if (internalLink[0] == '/query-detail-t2') {
      if (this.userData.role == 'Lenovo Partner' || this.userData.role == 'lenovo partner') {
        this.currentRole = 't3';
        this.selectedRole = 't2';
        // this.roleChange().then(() => {
        //   this.router.navigate(internalLink);
        // });
        this.fetchRoleBaseDetailForSwicth(internalLink)
      }
      else {
        this.getAppPages(userData.data, internalLink)
        // this.router.navigate(internalLink);
      }
    }
    else if (internalLink[0] == '/language' || internalLink[0] == '/language-new') {
      this.router.navigate(['/language-new']);
    }
    else {
      console.log('inside : ', internalLink)
      this.getAppPages(userData.data, internalLink)
      // this.router.navigate(internalLink);
    }
  }

  setupDeeplinkPwa(internalLink, nidParth, role) {
   if(nidParth){
    console.log('Deeplink data : ', internalLink, nidParth, role)
    let internalLink1: any = "";
    var searchData = nidParth.split('?')[1].split('&');
    if (nidParth.split('?')[1].split('&').length > 0) {
      let queryParams = {};
      searchData.filter(item => {
        queryParams[item.split('=')[0]] = item.split('=')[1]
        console.log('here datas  : ', queryParams)
      });
      internalLink1 = [internalLink, queryParams];
      this.navigateForDeeplink(internalLink1)
    } else
     {
      console.log('else : ')
      internalLink1 = [internalLink];
      this.navigateForDeeplink(internalLink1)
    }
   }
  }

  deeplinkingroute(nidParth, internalLink) {
    if (nidParth) {
      let param = nidParth.slice(1).split("&");
      let queryParams = {};
      param.forEach((element) => {
        let key = element.split("=")[0];
        let value = element.split("=")[1];
        queryParams[key] = value;
      });
      // this.router.navigate([internalLink, queryParams]);
      console.log("internalLink", internalLink);
      console.log(queryParams);
      this.router.navigate([internalLink], { queryParams: queryParams });
    } else {
      this.router.navigate([internalLink]);
    }
  }

  openPasswordPop() {
    this.forgotPasswordPop = true;
  }

  closeForgotPasswordPop() {
    this.forgotPasswordPop = false;
  }

  resetForgotPassword() {
    this.forgotPasswordPop = false;
    this.password1Sel = "";
    this.password1 = "";
    this.password2Sel = "";
    this.password2 = "";
    this.passwordError = {};
  }

  async changePassword() {
    if (
      this.password1Sel != "" &&
      this.password2Sel != "" &&
      this.password1Sel.length >= 8 &&
      this.password2Sel.length >= 8
    ) {
      let filter = {};

      if (this.userData["userId"]) {
        filter["user_id"] = this.userData["userId"];
      }

      if (this.password1Sel) {
        filter["password"] = window.btoa(this.password1Sel);
      }

      if (this.password2Sel) {
        filter["new_password"] = window.btoa(this.password2Sel);
      }

      await this.appCom.showLoader();
      this.getPostData
        .postDataFromApiCustom(API_ENDPOINT.changeProfilePassword, filter)
        .subscribe(
          async (data: any) => {
            if (data.status == "success") {
              // console.log("data",data);
              this.resetForgotPassword();
              this.showMessage(data.message);
              this.appCom.hideLoader();
            } else {
              this.appCom.hideLoader();
              this.appCom.showToast(data.message, "bottom");
            }
          },
          (error) => {
            this.appCom.hideLoader();
            this.appCom.showToast("Something went wrong", "bottom");
          }
        );
    } else if (this.password1Sel == "") {
      this.appCom.showToast("Please enter valid current password", "bottom");
    } else if (this.password1Sel.length < 8) {
      this.appCom.showToast(
        "Current Password should be of 8 characters long ",
        "bottom"
      );
    } else if (this.password2Sel == "") {
      this.appCom.showToast("Please enter valid new password ", "bottom");
    } else if (this.password2Sel.length < 8) {
      this.appCom.showToast(
        "New Password should be of 8 characters long ",
        "bottom"
      );
    } else {
      // this.passwordError['status'] = true;
      // this.appcom.showToast("Your password doesnt match with the confirmed password","bottom");
    }
  }

  async showMessage(msg) {
    let alert = await this.alertCtrl.create({
      message: "<img src='./assets/images/contact-us-thankyou.svg'>",
      cssClass: "alertionic-pop",
      subHeader: msg,

      buttons: [
        {
          text: "OK",
          role: "null",
          handler: () => {
            alert.dismiss();
          },
        },
      ],
    });
    await alert.present();
  }

  getAppPages(data, internalLink?) {

    // if((this.auth.menuArray.length <= 0 || !this.appCom.platform.is('cordova')) || internalLink){
    if((this.auth.menuArray.length <= 0 || !this.appCom.platform.is('cordova') || this.appCom.platform.is('cordova')) || internalLink){
        let roleBaseData;
      let forRoleData;
      let forRoleData1;
      this.appCom.switchArray = [];
      this.activateRoleArray = [];
      this.auth.menuArray = [];
      this.auth.restirctedArray = [];
      this.authGuard.restrictedMenuArray = [];
      this.appCom.getLocalStorageItem('MenuUpdatedOn').then((menuUpdatedOn: any) => {
        //load menu from server only when dates are not matching
        if (menuUpdatedOn && (this.checkDatesEqual(new Date(menuUpdatedOn), new Date()))) {
          console.log("Menu already updated on " + menuUpdatedOn);
          this.appCom.getLocalStorageItem('getAppMenuListResponse').then((res: any) => {
            this.auth.menuArray = [];
            res.menuList.menu_list.filter(item => {
              this.auth.menuArray.push(item.route)
            })
            this.auth.restirctedArray = [...res.restrictedPageList];
            this.authGuard.restrictedMenuArray = [...res.restrictedPageList]
          });

        } else {
          // fetch Menu array and restricted array
          this.getPostData.postDataFromApiCustom(API_ENDPOINT.appMenuList, {
            user_role: data.role.toLowerCase(),
            user_type: data.manage_user_type,
            user_id: data.userId,
            aso_type: data.aso_type,
            mobile: data.mobile
          }).subscribe((res: any) => {
            // this.auth.menuArray = [...res.menuList.field_menu_list];
            this.auth.menuArray = [];
            res.menuList.menu_list.filter(item => {
              this.auth.menuArray.push(item.route)
            })
            this.appCom.setLocalStorageItem('getAppMenuListResponse', res);
            this.appCom.setLocalStorageItem('menuArray', res.menuList.menu_list);
            this.appCom.setLocalStorageItem('otherRoleMenuArray', res.userMenuList);
            this.appCom.setLocalStorageItem("MenuUpdatedOn", new Date());
            this.auth.restirctedArray = [...res.restrictedPageList];
            this.authGuard.restrictedMenuArray = [...res.restrictedPageList]
          }, err => {
            console.log('error menu content : ', err)
          });
        }
      });
  
      this.getPostData.postDataFromApiCustom(API_ENDPOINT.rolebaseConfig, { user_id: data.userId }).subscribe((res: any) => {
        console.log('res ponse config ', res)
  
        // get rolebaseconif data from storage
        roleBaseData = res.roleBasedData;
        this.appCom.setLocalStorageItem('roleBaseConfig', res.roleBasedData);
  
        // get User Role based data from storage
        forRoleData = res.userRoleBasedData[0].field_list_of_for_role;
        this.appCom.setLocalStorageItem("userRoleBaseData", res.userRoleBasedData);
        forRoleData1 = [...forRoleData];
        this.getPostData.postDataFromApiCustom(API_ENDPOINT.getSelfRegister).subscribe(async (resData: any) => {
          console.log('Data in home PAGE : ', resData);
  
          this.appCom.switchArray = [];
          this.activateRoleArray = [];
          // push role who can switch
          forRoleData1.filter(item => {
            roleBaseData.filter(item1 => {
              if (item == item1.label) {
                this.appCom.switchArray.push(item);
                item = '';
              }
            })
            return item;
          });
  
          // puch role who can activate 
          forRoleData1.filter(item => {
            resData.getSelfRoleList.filter(item1 => {
              if (item == item1.label) {
                let param = {
                  label: item1.label,
                  role: item1.field_role_name,
                  aso_type: item1.field_type_of_aso[0]
                }
                this.activateRoleArray.push(param);
              }
            })
          })
  
          // remove the role which is present in siwtch array
          this.appCom.switchArray.filter(item => {
            this.activateRoleArray.filter((item1, index) => {
              if (item == item1.label) {
                this.activateRoleArray.splice(index, 1);
              }
              return item1;
            })
          })
  
          // make a copy of array
          let appPages = [...this.auth.appPages];
          // get the label for t3 t2 etc 
          this.getPostData.getLabelFromJson().subscribe(res => {
            console.log('Label of : ', res);
            // this.labelName = res;
  
            this.appCom.getLocalStorageItem('userData').then((resUserData: any) => {
              let currentRole = resUserData.data.role.toLowerCase();
  
              appPages.filter((item: any, index) => {
                if (item.url == '/terms' && !item.name) {
                  // this.switchArray.filter((item1, index1) => {
  
                  //   this.appCom.getLocalStorageItem('roleBaseConfig').then((resData: any) => {
                  //     resData.filter(itemData => {
                  //       if (itemData.label == item1) {
                  //         let param = {
                  //           title: 'Switcher to ' + res[itemData.label],
                  //           url: '/switch',
                  //           icon: 'icon-switcher',
                  //           open: false,
                  //           status: currentRole.toLowerCase() == item1 ? false : true,
                  //           name: res[itemData.label],
                  //           userId: itemData.userID ? itemData.userID : itemData.userId
                  //         }
                  //         appPages.splice(index + 1, 0, param);
                  //       }
                  //     })
                  //   })
  
                  // })
  
                  if (this.appCom.switchArray.length > 1) {
                    let param = {
                      title: 'Switcher',
                      url: '/switch',
                      icon: 'icon-switcher',
                      open: false,
                      status: true,
                      res: res
                    }
                    appPages.splice(index + 1, 0, param)
                    this.showRoleSwitch = true;
                  }
  
                  this.activateRoleArray.filter((item2, index2) => {
                    console.log('inside activate role loop : ', item2)
                    let param = {
                      title: 'Activate as ' + res[item2.label],
                      url: '/activate-role',
                      icon: 'icon-refer',
                      open: false,
                      status: true,
                      name: res[item2.label],
                      role: item2.role,
                      aso_type: item2.aso_type
                    }
                    appPages.splice(index + 1, 0, param);
                  })
  
                }
  
              })
            });
  
          }, err => {
            console.log('err = : ', err);
          })
  
  
  
          this.appCom.appPagesChages.next(appPages);
          this.events.publish('appPageChanges', appPages);
          console.log('Switch Array : ', this.appCom.switchArray, this.activateRoleArray, this.auth.appPages, appPages)
          // this.footerTab.initFooterUserData();
          // this.showFooter = true;
          if (internalLink) {
            console.log('Inside getApps : ', internalLink[0].split('/')[1] + ' : ', internalLink);
            // this.events.publish('menu:pagechange', true, internalLink[0].split('/')[1]);
            if(!this.appCom.platform.is('cordova')){
  
              if(!this.router.isActive(internalLink,false))
              this.router.navigate(internalLink).then(() => {
                this.splashScreen.hide();
              });
            }else{
              this.router.navigate(internalLink).then(() => {
                this.splashScreen.hide();
              });
  
            }
          }
        });
      })
    }
    else {
      if (internalLink) {
        console.log('Inside getApps : ', internalLink[0].split('/')[1] + ' : ', internalLink);
        // this.events.publish('menu:pagechange', true, internalLink[0].split('/')[1]);
        if(!this.appCom.platform.is('cordova')){

          if(!this.router.isActive(internalLink,false))
          this.router.navigate(internalLink).then(() => {
            this.splashScreen.hide();
          });
        }else{
          this.router.navigate(internalLink).then(() => {
            this.splashScreen.hide();
          });

        }
      }
    }
  }

  checkDatesEqual(date1: Date, date2: Date) {
    console.log(date1 + "   " + date2)
    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);

    if (date1.setHours(0, 0, 0, 0) == date2.setHours(0, 0, 0, 0)) {
      return true;
    } else {
      return false;
    }
  }


}